// TicketResolutionPanel.tsx
import React from 'react';
import { Box, Typography, Divider, Button, Skeleton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import SendIcon from '@mui/icons-material/Send';
import FeedbackInput from '../feedbackInput';


const TicketResolutionPanel: React.FC<{
    rating: number;
    setRating: (value: number) => void;
    feedback: string;
    feedbackInputRef: React.RefObject<{ focus: () => void; getValue: () => string }>;
    isSubmitting: boolean;
    handleConfirmResolution: () => void;
    resolvingLoading: boolean;
    setResolving: (value: boolean) => void;
}> = ({
    rating,
    setRating,
    feedback,
    feedbackInputRef,
    isSubmitting,
    handleConfirmResolution,
    resolvingLoading,
    setResolving
}) => {
    if (resolvingLoading) {
        return (
            <Box>
                <Skeleton variant="text" width="60%" height={30} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={50} sx={{ mb: 2, borderRadius: 2 }} />
                <Skeleton variant="text" width="40%" height={20} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ mb: 3, borderRadius: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={40} sx={{ mb: 1, borderRadius: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
            </Box>
        );
    }

    return (
        <>
            <Typography fontWeight={600} mb={2}>Evaluar Ticket</Typography>
            <Typography fontWeight={500}>¿Cómo calificarías la resolución?</Typography>

            <Box display="flex" justifyContent="center" gap={0.5} mt={1}>
                {[1, 2, 3, 4, 5].map((value) =>
                    rating >= value ? (
                        <StarIcon
                            key={value}
                            onClick={() => setRating(value)}
                            sx={{ cursor: 'pointer', fontSize: 30, color: '#FACC15' }}
                        />
                    ) : (
                        <StarBorderIcon
                            key={value}
                            onClick={() => setRating(value)}
                            sx={{ cursor: 'pointer', fontSize: 30, color: '#D1D5DB' }}
                        />
                    )
                )}
            </Box>

            <Typography variant="body2" mt={3}>💬 Comentarios</Typography>
            <FeedbackInput ref={feedbackInputRef} initialValue={feedback} isSubmitting={isSubmitting} />

            <Divider sx={{ my: 3 }} />

            <Button
                variant="contained"
                fullWidth
                startIcon={<SendIcon />}
                style={{ backgroundColor: '#E9D5FF', color: '#6B21A8', fontWeight: 'bold', }}
                onClick={handleConfirmResolution}
                disabled={rating === 0}
            >
                Marcar como resuelto
            </Button>

            <Button
                variant="outlined"
                fullWidth
                sx={{ color: '#7C3AED', borderColor: '#E9D5FF', fontWeight: 'bold' }}
                onClick={() => setResolving(false)}
            >
                Cancelar
            </Button>
        </>
    );
};

export default TicketResolutionPanel;
